import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=4509ba26&scoped=true"
import script from "./back-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./back-button.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./back-button.vue?vue&type=style&index=0&id=4509ba26&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509ba26",
  null
  
)

export default component.exports